/* eslint-disable */
// @ts-nocheck
import { reducerWrapper } from '../support/utils';
import {
  DELETE_APP_STORE_CONNECT_CREDENTIALS,
  GET_APP_STORE_CONNECT_CREDENTIALS,
  GET_APP_VERIFICATION_STATUS,
  SAVE_APP_STORE_CONNECT_CREDENTIALS,
  VERIFY_APP,
} from '../actions/AppStoreConnectActions';
import type { AppStoreVerificationReducer as AppStoreVerificationReducerState } from '../types/appStoreConnectTypes';
const INIT_STATE: AppStoreVerificationReducerState = {
  appStoreConnectCredentials: undefined,
  verificationStatus: undefined,
};
export function Handler(
  state: AppStoreVerificationReducerState = INIT_STATE,
  action: {
    type: string;
    data: any;
  }
) {
  switch (action.type) {
    case SAVE_APP_STORE_CONNECT_CREDENTIALS.response:
    case GET_APP_STORE_CONNECT_CREDENTIALS.response:
    case DELETE_APP_STORE_CONNECT_CREDENTIALS.response:
      return { ...state, appStoreConnectCredentials: action.data };

    case GET_APP_VERIFICATION_STATUS.response:
    case VERIFY_APP.response:
      return {
        ...state,
        verificationStatus: action.data.verificationStatus,
        iosAppStoreId: action.data.iosAppStoreId,
        iosAppStoreIdVerified: action.data.iosAppStoreIdVerified,
      };

    default:
      return state;
  }
}
const AppStoreVerificationReducer = reducerWrapper(INIT_STATE, Handler, {
  request: [],
  error: [],
  resetOn: ['APP_CHANGE'],
});
export default AppStoreVerificationReducer;
